import React, {
  useState,
  useEffect,
  useContext,
  useImperativeHandle,
  forwardRef,
} from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { AppContext } from "../context/AppContext";
import api from "../services/api";
var emailOtpResponse = {};

const EmailOtp = forwardRef(function EmailOtp(
  { name = "email", required = true, unique = false },
  ref
) {
  const [formInputData, setFormInputData] = useState({
    email: "",
    emailVerified: false,
  });
  const [setLoaderActive, toast] = useContext(AppContext);
  //const [email, setEmail] = useState('gaurav.singh@mahiruho.com');
  const [emailOtp, setEmailOtp] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  //const [emailVerified, setEmailVerified] = useState(false);
  const [emailOtpCount, setEmailOtpCount] = useState(0);
  const [emailMinutes, setEmailMinutes] = useState(0);
  const [emailSeconds, setEmailSeconds] = useState(0);
  const handleEmail = async () => {
    if (formInputData.email && isEmailValid) {
      setLoaderActive(true);
      setEmailMinutes(1);
      setEmailSeconds(30);
      try {
        await api
          .get("/registration/send-otp-on-email/", {
            params: { key: formInputData.email, unique: unique },
          })
          .then((response) => response.data)
          .then((data) => {
            if (data.success) {
              emailOtpResponse = data.response;
              setEmailOtpCount(emailOtpCount + 1);
            } else throw new Error(data.response);
          });
      } catch (ex) {
        toast.error(ex.message);
        setEmailMinutes(0);
        setEmailSeconds(0);
      } finally {
        setLoaderActive(false);
      }
    } else {
      console.log("Invalid Email Address");
    }
  };
  const handleEmailOtp = async () => {
    if (formInputData.email && isEmailValid) {
      if (!isNaN(emailOtp) && emailOtp.length === 6) {
        try {
          setLoaderActive(true);
          emailOtpResponse.otp.otp = emailOtp;
          await api
            .post("/registration/verify-otp-on-email/", emailOtpResponse)
            .then((response) => response.data)
            .then((data) => {
              if (data.success) {
                setFormInputData({ ...formInputData, emailVerified: true });
              } else throw new Error(data.response);
            });
        } catch (ex) {
          setFormInputData({ ...formInputData, emailVerified: false });
          toast.error(ex.message);
        } finally {
          setEmailMinutes(0);
          setEmailSeconds(0);
          setLoaderActive(false);
        }
      }
    } else {
      console.log("Invalid Email Address");
    }
  };

  const resetEmail = (e) => {
    emailOtpResponse = {};
    setIsEmailValid(true);
    setEmailOtpCount(0);
    setFormInputData({ ...formInputData, emailVerified: false });
    setEmailOtp("");
    // timestampEmail = undefined;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (emailSeconds > 0) {
        setEmailSeconds(emailSeconds - 1);
      }

      if (emailSeconds === 0) {
        if (emailMinutes === 0) {
          clearInterval(interval);
        } else {
          setEmailSeconds(59);
          setEmailMinutes(emailMinutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [emailSeconds]);

  const handleInputChange = (event) => {
    const inputFieldValue = event.target.value;
    const NewInputValue = {
      ...formInputData,
      email: inputFieldValue,
    };
    setFormInputData(NewInputValue);
  };
  useImperativeHandle(
    ref,
    () => {
      return {
        value: { ...formInputData },
      };
    },
    [formInputData]
  );
  return (
    <Form.Group className="mb-3">
      <InputGroup>
        <Form.Control
          placeholder="Email Address"
          aria-label="Email Address"
          aria-describedby="email-verify"
          name={name}
          type="email"
          value={formInputData.email}
          required={required}
          onChange={handleInputChange}
          readOnly={formInputData.emailVerified}
        />
        <Button
          variant="outline-secondary"
          id="email-verify"
          onClick={handleEmail}
          disabled={
            formInputData.emailVerified || emailSeconds > 0 || emailMinutes > 0
          }
        >
          {formInputData.emailVerified ? (
            "Verified"
          ) : emailOtpCount === 0 ? (
            "Send OTP"
          ) : emailSeconds > 0 || emailMinutes > 0 ? (
            <>
              {emailMinutes < 10 ? `0${emailMinutes}` : emailSeconds}:
              {emailSeconds < 10 ? `0${emailSeconds}` : emailSeconds}
            </>
          ) : (
            <>Resend OTP</>
          )}
        </Button>
        {!formInputData.emailVerified && (
          <>
            <Form.Control
              placeholder="Email OTP"
              aria-label="Email OTP"
              value={emailOtp}
              onChange={({ target }) => setEmailOtp(target.value)}
            />
            <Button variant="outline-secondary" onClick={handleEmailOtp}>
              Verify
            </Button>
          </>
        )}
      </InputGroup>
      {formInputData.emailVerified && (
        <>
          <Button variant="link" onClick={resetEmail}>
            Want to change email?
          </Button>
        </>
      )}
    </Form.Group>
  );
});

export default EmailOtp;
